'use strict';
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
const react_1 = __importDefault(require('react'));
const form_1 = require('../contexts/form');
function ErrorMsgs(extraProps) {
  const { errors } = (0, form_1.useInternalForm)();
  if (!errors.length)
    return react_1.default.createElement(react_1.default.Fragment, null);
  return react_1.default.createElement(
    'ul',
    Object.assign({}, extraProps),
    errors.map(msg => react_1.default.createElement('li', { key: msg }, msg))
  );
}
exports.default = ErrorMsgs;
//# sourceMappingURL=ErrorMsgs.js.map
